<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CCol md="6" lg="6" xl="6"> Registrar Riego </CCol>
            <CCol md="6" lg="6" xl="6">
              <router-link
                :to="{ name: 'Riego', params: { config: config } }"
                class="float-right"
              >
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />
                  Regresar
                </CButton>
              </router-link>

              <CButton
                style="margin-bottom: 10px; height: 35px;"
                @click="successModalLabor = true"
                color="primary"
                class="float-right mr-1 btn-header"
              >
                Limpiar tabla
              </CButton>
            </CCol>
          </CCardHeader>
          <CCardBody style="margin-top: 0px; padding-top: 10px;">
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="errores.length > 0 && errores.length < 20"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #COPIAR="{ item }">
                <th
                  style="padding: 10px 5px 5px 5px;"
                  :class="buscarError(item.pos)"
                >
                  <div class="popUp" v-show="item.showpop && errores[item.pos]">
                    <span>{{ mensajeError(item.pos) }}</span>
                  </div>
                  <CButton
                    tabindex="-1"
                    style="width: 20px; height: 20px; padding: 1px;"
                    color="ghost-light"
                    @click="copyAll(item.pos)"
                    square
                    size="sm"
                  >
                    <!-- <CIcon style="width:10px; margin: 0px;" name="cil-copy" /> -->
                    <img
                      style="width:15px; height: 15px;"
                      src="../../../assets/icons/copy.png"
                      class="imagen"
                    />
                  </CButton>
                  <CButton
                    tabindex="-1"
                    style="width: 20px; height: 20px; padding: 1px; margin-top:15px;"
                    color="warning"
                    v-show="
                      errores.find(fila => fila.pos == item.pos)
                        ? errores.find(fila => fila.pos == item.pos).fail
                          ? true
                          : false
                        : false
                    "
                    @click="mostrarPop(item.pos)"
                    square
                    size="sm"
                  >
                    <CIcon
                      style="width:10px; margin: 0px;"
                      name="cil-warning"
                    />
                  </CButton>
                </th>
              </template>
              <template #FECHA="{ item, index }">
                <td
                  :class="buscarError(item.pos)"
                  style="position:relative; padding: 10px 5px 5px 5px;"
                >
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <input
                      class="form-control fechaInput"
                      type="date"
                      name="fecha"
                      v-model="items[index].fechahora"
                    />
                    <!-- <input class="form-control fechaInput" :value="item.pos > 8 ? '2021-02-'+(item.pos+1) : '2021-02-0'+(item.pos+1)" type="date" name="fecha"  :id="'fecha'+item.pos" :ref="'fecha'+item.pos"> -->
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la fecha en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'fechahora')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #UBICACION="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <Treeselect
                      style="width: 90%;"
                      v-model="items[index].ubicacion_id"
                      :options="ubicaciones"
                      placeholder="Selecciona una ubicación"
                      :ref="'ubicacion' + item.pos"
                      title="Selecciona una ubicación"
                      :key="item.pos"
                    >
                    </Treeselect>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la ubicación en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarCelda(index, 'ubicacion_id')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>

              <template #ENTRADA_LT="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].entrada_lt"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'entrada_lt')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #ENTRADA_PH="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].entrada_ph"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'entrada_ph')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #ENTRADA_CE="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].entrada_ce"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'entrada_ce')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #SALIDA_LT="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].salida_lt"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'salida_lt')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #SALIDA_PH="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].salida_ph"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'salida_ph')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #SALIDA_CE="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      class="form-control"
                      v-model="items[index].salida_ce"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                    <span style=" margin-left: 5px; margin-top: 5px;">
                      {{getUnidad(item.pos)}}
                    </span>
                    <CButton
                      v-c-tooltip="{
                        content:
                          'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement:
                          item.pos == items.length - 1 ? 'right-end' : 'right'
                      }"
                      tabindex="-1"
                      class="buttonClon"
                      @click="clonarInfo(item.pos, 'salida_ce')"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <img
                        style="width:13px; height: 13px;"
                        src="../../../assets/icons/down.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
              <template #DRENADO="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row">
                    <input
                      disabled
                      class="form-control"
                      :value="$formatter((items[index].salida_lt/items[index].entrada_lt)*100)"
                      type="number"
                      style="width: calc(100% - 40px); padding: 5px; margin-left: 15px;"
                    />
                  </div>
                </td>
              </template>


              <template #BORRAR="{ item }">
                <td :class="buscarError(item.pos)">
                  <div>
                    <CButton
                      tabindex="-1"
                      style="width: 20px; height: 20px; padding: 1px;"
                      @click="borrarFila(item.pos)"
                      color="ghost-light"
                      square
                      size="sm"
                    >
                      <!-- <CIcon style="width:15px; margin: 0px;" name="cil-trash" /> -->
                      <img
                        style="width:15px; height: 15px;"
                        src="../../../assets/icons/trash.png"
                        class="imagen"
                      />
                    </CButton>
                  </div>
                </td>
              </template>
            </CDataTable>

            <CCol sm="12" md="9" lg="9">
              <KlayFileDD
                :fetching="fetching"
                v-model="medias"
                :label="`Anexos: `"
                @onFetch="
                  () => {
                    fetching = false;
                  }
                "
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                :fetchMethod="pushMedia"
                :baseSrc="$store.getters.MediaGet"
              />
            </CCol>
          </CCardBody>

          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Labor', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>
            <CButton
              v-if="errores.length > 0 && errores.length < 21"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton
              v-else
              @click="addLabores()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}
      </CModal>
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        :closeOnBackdrop="false"
        color="info"
        :show.sync="successModal"
        class="text-center"
      >
        <span v-if="errores.length >= 0 && errores.length < 21">
          ¡Un momento, la información se está guardando!.
        </span>
        <span v-else>La información se ha procesado</span>
        <template #footer>
          <CButton
            v-if="errores.length >= 0 && errores.length < 21"
            class="px-4 mx-3 btn-lg"
            color="info"
          >
            <div>
              <div
                class="w-100 d-flex justify-content-center align-items-center"
              >
                <div class="sk-flow height-custom flex align-items-center">
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                  <div class="sk-flow-dot bg-load-white"></div>
                </div>
              </div>
            </div>
          </CButton>
          <CButton
            v-else
            @click="revisarErrores()"
            class="px-4 mx-3 btn-lg"
            color="info"
          >
            <span>Aceptar</span>
          </CButton>
        </template>
      </CModal>
    </CRow>
    <CModal
      size="lg"
      :show.sync="modalUbicaciones"
      :no-close-on-backdrop="true"
      :centered="false"
      title="Ubicaciones"
      color="info"
    >
      <CDataTable
        hover
        bordered
        small
        fixed
        :loading="isLoading"
        :items="filteredItems"
        :fields="fieldsUbi"
        :noItemsView="noItems"
        style="height: 60vmin;"
        class="table-responsive"
      >
        <template #nombre="{item, index}">
          <td v-if="filter" class="py-2 ">
            {{ item.payload.nombre }}
          </td>
          <td
            v-else
            class="py-2"
            :class="
              `${
                ubicacionesJ.filter(
                  hijo => hijo.payload.pertenece_id == item.id
                ).length > 0
                  ? `cursor-p`
                  : ``
              }`
            "
            @click="toggleUbicaciones(index)"
          >
            <span>
              <CIcon
                v-if="
                  ubicacionesJ.filter(
                    hijo => hijo.payload.pertenece_id == item.id
                  ).length > 0
                "
                name="cil-chevron-circle-down-alt"
              />
            </span>
            {{ item.payload.nombre }}
          </td>
        </template>
        <template #details="{item, index}">
          <CCollapse :show="details.includes(index)">
            <TableCollapse
              :key="posLabor"
              @click-cancel="toggleCancel"
              @click-print="printNanoid"
              :avisar="onResultados"
              :ubicacionPadre="item.id"
              :cultivos="cultivos"
              :ubicaciones="
                ubicacionesJ.filter(hijo => hijo.payload.raiz_id == item.id)
              "
            ></TableCollapse>
          </CCollapse>
        </template>
      </CDataTable>
      <template #footer>
        <CButton @click="agregarUbicaciones()" color="info">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Ubicaciones"
      :centered="true"
      color="warning"
      :show.sync="modalUbicacionPadre"
      :closeOnBackdrop="false"
      :fade="true"
      >Tienes una ubicación padre/hijo seleccionada
      <template #footer>
        <CButton @click="modalUbicacionPadre = false" color="warning"
          >Aceptar</CButton
        >
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Labor"
      :centered="true"
      color="warning"
      :show.sync="successModalLabor"
      >Se limpiara la información de la tabla.
      <template #footer>
        <CButton @click="successModalLabor = false" color="secondary"
          >Cancelar</CButton
        >
        <CButton @click="limpiarTabla()" color="warning">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Labor"
      :centered="true"
      color="info"
      :show.sync="modalCopiar"
      >Ya no hay espacios disponibles para poder copiar.
      <template #footer>
        <CButton @click="modalCopiar = false" color="info">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

// import "vue-select/dist/vue-select.css";
import moment from "moment";

import Treeselect from "@riophae/vue-treeselect";
import TableCollapse from "../../../customComponents/TableCollapse1";
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { createPopper } from "@popperjs/core";

const fields = [
  { key: "COPIAR", label: "", _style: "width:1%" },
  { key: "FECHA", label: "Fecha", _style: "width:15%" },
  { key: "UBICACION", label: "Ubicación", _style: "width:15%" },
  { key: "ENTRADA_LT", label: "Entrada Lt", _style: "width:10%" },
  { key: "ENTRADA_PH", label: "pH", _style: "width:10%" },
  { key: "ENTRADA_CE", label: "Ce", _style: "width:10%" },

  { key: "SALIDA_LT", label: "Salida Lt", _style: "width:10%" },
  { key: "SALIDA_PH", label: "pH", _style: "width:10%" },
  { key: "SALIDA_CE", label: "Ce", _style: "width:10%" },

  { key: "DRENADO", label: "Drenado", _style: "width:10%" },
  { key: "BORRAR", label: "", _style: "width:1%" }
];
const fieldsUbi = [
  { key: "nombre", label: "Ubicaciones", _style: "width:50%" }
];
export default {
  name: "NuevoLabor",

  components: {
    TableCollapse,
    Treeselect
  },

  data() {
    return {
      modalCopiar: false,
      valTree: "",
      tablaRiegos: false,
      value: [],
      placement: "bottom-start",
      nodeCtividad: null,
      hoverM: false,
      errores: [],
      enviado: true,
      ubicacionesJ: [],
      ubicacionesSelec: [],
      posLabor: 0,
      details: [],
      cultivos: [],
      items: [],
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados"
      },
      optionsGroup: [],
      pruebaActividades: [
        {
          id: 1,
          label: "Cosecha",
          children: [
            {
              id: 2,
              label: "Prueba",
              children: [{ id: 3, label: "Prueba1", position: 3 }],
              position: 2
            }
          ],
          position: 1
        }
      ],
      modalUbicaciones: false,
      fields,
      fieldsUbi,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      modalUbicacionPadre: false,
      date: null,
      multi: null,
      config: this.$route.params.config,
      cantidad: 1,
      cantidadCosto: 1,
      trabajador: null,
      trabajadores: [],
      trabajadoresAll: [],
      categorias: [],
      categoriasAll: [],
      actividad: null,
      actividades: [],
      actividadesAll: [],
      ubicacion: null,
      ubicaciones: [],
      ubicacionesAll: [],
      tiempo_extra: false,
      isFijo: false,
      isLoading: false,
      isLoadingPage: false,
      unidad: "kg",
      unidadPagar: "dia",
      warningModal: false,
      successModal: false,
      successModalLabor: false,
      error: "",
      configurationToggle: true,
      response: false,
      pos: 0,
      fetching: false,
      medias: []
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    cantidad: {
      required,
      notNegative: value => value >= 0
    },
    cantidadCosto: {
      required
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    filteredItems() {
      if (this.filter) {
        return this.ubicacionesJ.filter(i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        );
      } else {
        return this.ubicacionesJ.filter(i => i.payload.pertenece_id == 0);
        // .filter(i =>
        //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        // );
      }
    },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.actualizarInfo();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;
    document.addEventListener("wheel", function() {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });
    for (let index = 0; index < 21; index++) {
      this.items.push({
        pos: index,
        fechahora: "",
        ubicacion_id: null,
        entrada_lt:null,
        entrada_ph:null,
        entrada_ce:null,
        salida_lt:null,
        salida_ph:null,
        salida_ce:null,
      });
    }
    this.$store
      .dispatch("customHTTP", {
        schema: "configuracion",
        filter: {
          where: [
            {
              field: "payload->parametro",
              value: "modo_calculo_horas_extras",
              operator: "="
            }
          ]
        }
      })
      .then(response => {
        this.configurationToggle =
          response.data[0].payload.valor === "auto" ? false : true;
        // response.data[0].payload.valor === 'auto' ? false : this.fields.splice(7,0,{ key: "TIEMPO_EXTRA", label: "Tiempo Extra", _style: "width:10%" });
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => (this.isLoadingPage = false));
    this.actualizarInfo();
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async m => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    revisarErrores() {
      this.successModal = false;
      let error = this.errores.find(element => element.fail == true);
      if (!error) {
        this.errores = [];
        for (let index = 0; index < this.items.length; index++) {
          //const element = this.items[index];
          // this.$refs['trabajador'+index]._data._value = null
          this.items[index].fechahora = null;
          this.items[index].ubicacion_id = null;

          this.items[index].entrada_lt = null;
          this.items[index].entrada_ph = null;
          this.items[index].entrada_ce = null;
          this.items[index].salida_lt = null;
          this.items[index].salida_ph = null;
          this.items[index].salida_ce = null;
        }
      }
    },
    withPopper(dropdownList, component) {
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            }
          }
        ]
      });
      return () => popper.destroy();
    },
    buscarError(item) {
      if (this.errores.find(fila => fila.pos == item)) {
        return this.errores.find(fila => fila.pos == item).fail
          ? "table-danger"
          : this.enviado
          ? "table-success"
          : "";
      }
    },
    mensajeError(item) {
      let error = this.errores.find(el => {
        if (el.pos == item) {
          return el;
        }
      });
      let msg = "";
      if (error) {
        if (error.error) {
          switch (error.error.message) {
            case "Los datos dados no eran válidos.":
              msg = "Algunos datos son requeridos";
              break;
            case "El campo fechahora es invalido.":
              msg = "La fecha ingresada es invalida";
              break;
            default:
              msg = error.error.message;
              break;
          }
        }
      }
      return msg;
    },
    mostrarPop(item) {
      this.items[item].showpop = !this.items[item].showpop;
    },
    onResultados(datos) {
      let ids = datos.payload.ruta.slice(1, -1).split("/");
      let exist = false;
      ids.forEach(ubicacionId => {
        if (
          this.ubicacionesSelec.find(
            ubicacion => ubicacion.value == ubicacionId
          ) &&
          ubicacionId !== ids[ids.length - 1]
        ) {
          this.modalUbicacionPadre = true;
          exist = true;
        }
      });

      if (exist == false) {
        this.ubicacionesSelec.forEach(ubicacion => {
          let ubicacionesRuta = ubicacion.ruta.slice(1, -2).split("/");
          ubicacionesRuta.forEach(ubicacionRuta => {
            if (ubicacionRuta == datos.id) {
              this.modalUbicacionPadre = true;
              exist = true;
            }
          });
        });
      }

      if (datos.selected && exist == false) {
        if (
          !this.ubicacionesSelec.find(ubicacion => ubicacion.value == datos.id)
        ) {
          this.ubicacionesSelec.push({
            value: datos.id,
            label: datos.payload.nombre,
            ruta: datos.payload.ruta
          });
        }
      } else {
        this.ubicacionesSelec = this.ubicacionesSelec.filter(
          ubicacion => ubicacion.value !== datos.id
        );
      }
    },
    copyAll(item) {
      let espacio = "";
      for (let i = item + 1; i < this.items.length; i++) {
        if (this.items[i].fechahora == "" && this.items[i].entrada_lt == null && this.items[i].entrada_ph == null && this.items[i].entrada_ce == null && this.items[i].salida_lt == null && this.items[i].salida_ph == null && this.items[i].salida_ce == null && this.items[i].ubicacion_id == null) {
          espacio = i;
          break;
        }
      }

      for (let itemMover = espacio; itemMover > item; itemMover--) {
        if (itemMover - 1 == item) {
          this.items[itemMover].fechahora = this.items[item].fechahora
          this.items[itemMover].ubicacion_id = this.items[item].ubicacion_id;

          this.items[itemMover].entrada_lt = this.items[item].entrada_lt;
          this.items[itemMover].entrada_ph = this.items[item].entrada_ph;
          this.items[itemMover].entrada_ce = this.items[item].entrada_ce;

          this.items[itemMover].salida_lt = this.items[item].salida_lt;
          this.items[itemMover].salida_ph = this.items[item].salida_ph;
          this.items[itemMover].salida_ce = this.items[item].salida_ce;

          if (this.errores.length > 0) {
            this.errores[itemMover] = itemMover;
          }
        } else {

          this.items[itemMover].fechahora = this.items[itemMover - 1].fechahora
          this.items[itemMover].ubicacion_id = this.items[itemMover - 1].ubicacion_id;

          this.items[itemMover].entrada_lt = this.items[itemMover - 1].entrada_lt;
          this.items[itemMover].entrada_ph = this.items[itemMover - 1].entrada_ph;
          this.items[itemMover].entrada_ce = this.items[itemMover - 1].entrada_ce;

          this.items[itemMover].salida_lt = this.items[itemMover - 1].salida_lt;
          this.items[itemMover].salida_ph = this.items[itemMover - 1].salida_ph;
          this.items[itemMover].salida_ce = this.items[itemMover - 1].salida_ce;


          let laborError = this.errores.find(
            element => element.pos == itemMover - 1
          );
          if (this.errores.length > 0) {
            if (laborError) {
              this.errores[itemMover - 1].pos =
                this.errores[itemMover - 1].pos + 1;
              this.errores[itemMover] = this.errores[itemMover - 1];
            } else {
              this.errores[itemMover - 1] = this.errores[itemMover - 1] + 1;
              this.errores[itemMover] = this.errores[itemMover - 1];
            }
          }
        }
      }
      if (espacio == "") {
        this.modalCopiar = true;
      }
    },
    tipoActividad(item) {
      // let tipoPago = ""
      let tipo_pago = "";
      if (this.items[item].actividades) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );

        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        return tipo_pago;
      }
    },
    clonarCelda(item, fila) {
      let info = this.items[item][fila];
      for (let index = item + 1; index < this.items.length; index++) {
        if (this.items[index][fila] == "" || this.items[index][fila] == null) {
          this.items[index][fila] = info;
        } else {
          break;
        }
      }
    },
    clonarInfo(item, fila) {
      let inputInfo = this.items[item][fila];
      for (let index = item + 1; index < this.items.length; index++) {
        if (this.items[index][fila] !== null && this.items[index][fila] !== "") {
          break;
        } else {
          this.items[index][fila] = inputInfo;
        }
      }
    },
    borrarFila(item) {
      this.items[item].fechahora = "";
      this.items[item].ubicacion_id = null;

      this.items[item].entrada_lt = null;
      this.items[item].entrada_ph = null;
      this.items[item].entrada_ce = null;

      this.items[item].salida_lt = null;
      this.items[item].salida_ph = null;
      this.items[item].salida_ce = null;

      for (let index = 0; index < this.errores.length; index++) {
        if (item == 0) {
          if (this.errores[index].pos == 0) {
            this.errores[index] = item;
            break;
          }
        }
        if (this.errores[index].pos) {
          if (this.errores[index].pos == item) {
            this.errores[index] = item;
            break;
          }
        }
      }
    },
    limpiarTabla() {
      this.successModalLabor = false;
      this.errores = [];
      this.pos = 0;
      for (let index = 0; index < this.items.length; index++) {
        this.items[index].fechahora = null;
        this.items[index].ubicacion_id = null;

        this.items[index].entrada_lt = null;
        this.items[index].entrada_ph = null;
        this.items[index].entrada_ce = null;

        this.items[index].salida_lt = null;
        this.items[index].salida_ph = null;
        this.items[index].salida_ce = null;

      }
    },
    agregarUbicaciones() {

      this.items[this.posLabor].ubicaciones = this.ubicacionesSelec;
      this.modalUbicaciones = false;
      this.$store.dispatch("updateStatus", true);
      this.ubicacionesSelec = [];
      this.details = [];
    },
    obtenerUbicaciones(item) {
      this.$store.dispatch("updateStatus", false);
      // this.details = []
      this.modalUbicaciones = true;
      this.posLabor = item;
      this.$store.state.count = [];
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    printNanoid(ubicacion, cant) {
      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    getUnidadLabor() {
      if (this.actividad) {
        // let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        return actSelect ? ` (${actSelect.payload.unidad})` : "";
      }
      return "";
    },
    getUnidadPagarLabor() {
      if (this.actividad && this.trabajador) {
        let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.trabajador.value
          );
          if (trabSelect) {
            return this.tiempo_extra
              ? ` (${trabSelect.payload.unidad_extra})`
              : ` (${trabSelect.payload.unidad})`;
          }
        }
      }
      return "";
    },
    getUnidad(item) {
      if (this.items[item].actividades) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );
        return actSelect ? ` ${actSelect.payload.unidad}` : "";
      }
      return "";
    },
    getUnidadPagar(item) {
      if (this.items[item].actividades && this.items[item].trabajador) {
        let tipo_pago = "";
        let tiempo_Extra = this.$refs["switch" + item].state;
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.items[item].trabajador
          );
          if (trabSelect) {
            return tiempo_Extra
              ? ` ${trabSelect.payload.unidad_extra}`
              : ` ${trabSelect.payload.unidad}`;
          }
        }
      }
      return "";
    },
    tiempoExtra() {
      // console.log(this.$refs['switch'+item].state)
    },
    filtrarActividad() {
      if (this.actividad) {
        // console.log();
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        // console.log(this.actividadesAll);
        // console.log(this.actividad);
        // console.log(actSelect);
        actSelect.payload.tipo_pago.toLowerCase() === "fijo"
          ? (this.isFijo = true)
          : (this.isFijo = false);
      }
    },
    actualizarInfo() {
      this.isLoadingPage = true;
      const ubicacionTemplateNoRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {

          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { id: ubicacion.id, label: ubicacion.payload.nombre };
          });

          this.ubicacionesJ = ubicaciones.data
            ? ubicaciones.data.map(ubi => {
                return { ...ubi, selected: false };
              })
            : [];

          this.optionsGroup = [];

          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    buscarRama(actividad, arrayRama) {
      for (let actHoja = 0; actHoja < arrayRama.length; actHoja++) {
        const actRaiz = arrayRama[actHoja];
        let actRama = actRaiz.children
          ? actRaiz.children.find(
              element => element.id == actividad.payload.pertenece_id
            )
          : false;
        if (actRama) {
          actRama.children
            ? actRama.children.push({
                id: actividad.id,
                label: actividad.payload.nombre,
                tipo_pago: actividad.payload.tipo_pago,
                tipo: actividad.payload.tipo
              })
            : (actRama.children = [
                {
                  id: actividad.id,
                  label: actividad.payload.nombre,
                  tipo_pago: actividad.payload.tipo_pago,
                  tipo: actividad.payload.tipo
                }
              ]);
          break;
        } else {
          if (arrayRama[actHoja].children) {
            this.buscarRama(actividad, arrayRama[actHoja].children);
          }
        }
      }
    },
    async addLabores() {
      this.isLoading = true;
      // this.errores = []
      this.enviado = false;
      this.successModal = true;
      console.log(this.items);

      this.fetching = true;
      this.isLoading = true;
      await new Promise((res, ) => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            clearInterval(iter);
            res();
          }
        }, 1000);
      });
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }
      this.agregarLabor();
      this.enviado = true;
      this.isLoading = false;
    },
    agregarLabor() {
      if (this.pos < this.items.length) {
        let labor = this.items[this.pos];
        let newDate = moment(
          this.items[labor.pos].fechahora,
          "YYYY-MM-DD HH:mm:ss"
        );
        let laborError = this.errores.find(element => element.pos == labor.pos);
        this.pos = this.pos + 1;

        if (laborError) {
          if (laborError.fail) {
            this.errores = this.errores.filter(el => el.pos !== labor.pos);
            if (
              labor.fechahora !== "" ||
              labor.entrada_lt !== null ||
              labor.entrada_ph !== null ||
              labor.entrada_ce !== null ||
              labor.salida_lt !== null ||
              labor.salida_ph !== null ||
              labor.salida_ce !== null ||
              labor.ubicacion_id !== null
              ) {
                const laborRequest =
                  this.$store.dispatch("customDocumentoAddHTTP", {
                    schema: "riego",
                    payload: {
                      encabezado: {
                        fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                        ubicacion_id: labor.ubicacion_id,
                        ubicacion_raiz_id: this.ubicacionRaiz
                          ? this.ubicacionRaiz.value
                          : null,
                        entrada_lt: Number(labor.entrada_lt),
                        entrada_ph: Number(labor.entrada_ph),
                        entrada_ce: Number(labor.entrada_ce),
                        salida_lt: Number(labor.salida_lt),
                        salida_ph: Number(labor.salida_ph),
                        salida_ce: Number(labor.salida_ce),
                      },
                      anexos: this.medias
                    }
                  });

                laborRequest
                  .then(msg => {
                    debugger
                    this.errores.push({
                      pos: labor.pos,
                      error: msg,
                      info: labor,
                      fail: false
                    });
                    this.agregarLabor();
                  })
                  .catch(msg => {
                    debugger
                    this.errores.push({
                      pos: labor.pos,
                      error: msg,
                      info: labor,
                      fail: true
                    });
                    this.agregarLabor();
                  })
                  .finally(() => {});

            }
          } else {
            this.errores = this.errores.filter(el => el.pos !== labor.pos);
            this.errores.push({
              pos: labor.pos,
              error: "",
              info: labor,
              fail: false
            });
            this.agregarLabor();
          }
        } else {
          this.errores = this.errores.filter(el => el !== labor.pos);
          if (
            labor.fechahora !== "" ||
            labor.entrada_lt !== null ||
            labor.entrada_ph !== null ||
            labor.entrada_ce !== null ||
            labor.salida_lt !== null ||
            labor.salida_ph !== null ||
            labor.salida_ce !== null ||
            labor.ubicacion_id !== null
          ) {

              const laborRequest =
                  this.$store.dispatch("customDocumentoAddHTTP", {
                    schema: "riego",
                    payload: {
                      encabezado: {
                        fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                        ubicacion_id: labor.ubicacion_id,
                        ubicacion_raiz_id: this.ubicacionRaiz
                          ? this.ubicacionRaiz.value
                          : null,
                        entrada_lt: Number(labor.entrada_lt),
                        entrada_ph: Number(labor.entrada_ph),
                        entrada_ce: Number(labor.entrada_ce),
                        salida_lt: Number(labor.salida_lt),
                        salida_ph: Number(labor.salida_ph),
                        salida_ce: Number(labor.salida_ce),
                      },
                      anexos: this.medias
                    }
                  });

              laborRequest
                .then(msg => {
                  debugger
                  this.errores.push({
                    pos: labor.pos,
                    error: msg,
                    info: labor,
                    fail: false
                  });
                  this.agregarLabor();
                })
                .catch(msg => {
                  debugger
                  this.errores.push({
                    pos: labor.pos,
                    error: msg,
                    info: labor,
                    fail: true
                  });
                  this.agregarLabor();
                })
                .finally(() => {});
          } else {
            let item = this.errores.find(el => el === labor.pos);
            if (item == 0) {
              this.agregarLabor();
            } else if (!item) {
              this.errores.push(labor.pos);
              this.agregarLabor();
            } else {
              this.agregarLabor();
            }
          }
        }
      } else {
        const renglonesConInfo = this.errores.filter(
          ff => typeof ff !== "number"
        );

        if (!!renglonesConInfo.length && renglonesConInfo.every(e => !e.fail)) {
          this.medias = [];
        }

        this.pos = 0;
      }
    },
    validateUbicacion() {
      if (this.multi) {
        const newUbicaciones = this.multi.map(ubi => {
          return ubi.value;
        });
        return newUbicaciones;
      } else {
        return null;
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateLabor() {
      this.$v.date.$touch();
      this.$v.cantidad.$touch();
      this.isFijo ? this.$v.cantidadCosto.$touch() : "";
      // this.$v.equivalencia_6oz.$touch();
    }
  }
};
</script>

<style src="../../../assets/scss/multiselect.css"></style>
<style src="../../../assets/scss/vue-select.css"></style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style src="../../../assets/scss/tree-select.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fechaInput {
  width: 90%;
  padding: 2px;
}
.selectFit {
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  padding-left: 0%;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  /* top: 3px; */
  /* right: 12px; */
  right: 10%;
  z-index: 1;
  color: black;
  opacity: 1;
}
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}
[data-popper-placement="bottom-start"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
td {
  position: relative;
  padding: 10px 5px 5px 5px;
}
.popUp {
  position: absolute;
  display: block;
  width: 300px;
  z-index: 2;
  background-color: rgb(255, 0, 0);
  border-radius: 10px;
  color: white;
  padding: 10px;
  margin-left: 35%;
  margin-top: 20px;
}
.buttonClon {
  width: 15px;
  height: 15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 10px;
  position: absolute;
  /* bottom: 20%;  */
  top: 30px;
  left: 90%;
  /* display: block !important; */
}
.btnUbi2 {
  /* border-left: 0ch; */
  border: 0ch;
  top: 8px;
  z-index: 2;
}
.buttonUbi {
  width: 17px;
  height: 17px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 0%;
  /* display: block !important; */
}
.buttonClonarUbi {
  width: 15px;
  height: 15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 5px;
  /* left: 85%; */
  /* display: block !important; */
}
.divUbi {
  width: 40px;
  position: absolute;
  bottom: 0;
  /* left:90%;
  bottom: 20%;  */
  z-index: 2;
  /* right: 10px; */
  display: inline !important;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
